<template>
  <v-dialog v-model="dialog" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mt-2" block color="info" v-on="on" v-bind="attrs"
        >Emitir Declaração Cursos</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="font-weight-bold green lighten-4"
        >Emitir Declaração Cursos Realizados</v-card-title
      >
      <v-card-text class="pt-4">
        <v-text-field
          label="Iniciados a partir de"
          type="date"
          v-model="dtini"
        ></v-text-field>
        <v-text-field
          label="Finalizados até"
          type="date"
          v-model="dtfim"
        ></v-text-field>
        <v-btn block rounded class="mt-3" color="info" @click="emitirDeclaracao()">Gerar declaração</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { getToken } from "@/global";

export default {
  data: () => ({
    dialog: false,
    dtini: moment(`${moment().toDate().getFullYear()}-01-01`).format(
      "YYYY-MM-DD"
    ),
    dtfim: moment().format("YYYY-MM-DD"),
  }),
  methods: {
    emitirDeclaracao() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/colaborador/treinamentos?funcao=EMITIR-DECLARACAO-CURSOS&token=${getToken()}&dtini=${this.dtini}&dtfim=${this.dtfim}`,
        "blank"
      );
    },
  },
};
</script>

<style>
</style>